enum Direction {
	LTR = 'LTR',
	RTL = 'RTL',
}

export default Direction;
